import { connect } from 'react-redux';

import MessagePending from '../preChecks/MessagePending';
import manualIdVerificationService from '../../../../services/manualidverification/ManualIdVerificationService';

function mapStateToProps(state) {
    const { remoteOralExam } = state;
    return {
        message: manualIdVerificationService.resolveManualIdVerificationWaitingMessage(remoteOralExam),
    };
}

const ManualIdVerificationPending = connect(mapStateToProps)(MessagePending);

export default ManualIdVerificationPending;
